import React, {Component} from 'react'
import Header from "../components/header"
import MainNav from "../components/mainNav"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import api from "../../api/api"
class InformationDetail extends Component {
	state={
		detail:{},
		navs:[
			{name:'首页',link:'/'},
			{name:'留学资讯',link:'/information'},
			{name:'资讯详情',link:'/informationdetail'},
		]
	}
	componentDidMount() {
		this.getDetail()
	}
	getDetail=async ()=>{
		let res=await api.get('/news/get-detail',{id:this.props.match.params.id})
		this.setState({
			detail:res.data.detail
		})
		// console.log(res)
	}
	render() {
		let {navs,detail}=this.state
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<MainNav navs={navs}/>
					<div className={'detail'}>
						<div className={'title'}>{detail.title}</div>
						<div className={'time_type'}>
							<img src={require('../../static/images/infotime.png')} alt=""/>
							<span className={'tt'}>{detail.updated_at}</span>
							<img src={require('../../static/images/shu.png')} alt=""/>
							<span className={'guojia'}>{detail.category}_</span>
							<span>{detail.category}</span>
						</div>
						<div className={'infobox'} dangerouslySetInnerHTML={{__html:detail.content}}/>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default InformationDetail